import { Manager as HammerManager, Tap } from "hammerjs";
import { useEffect, useRef } from "react";
import "./index.css";

export default function Overlayer({ height, onTapEvent }) {
  const el = useRef(null);

  useEffect(() => {
    const mc = new HammerManager(el.current, {
      recognizers: [[Tap]],
    });
    mc.set({ enable: true });
    mc.on("tap", (evt) => {
      onTapEvent && onTapEvent(evt);
    });
    return () => mc.destroy();
  }, [onTapEvent]);

  return <div ref={el} className="overlayer" style={{ height }}></div>;
}
